import { Routes, Route, Navigate } from "react-router-dom";
import Business from "../pages/Business/Business";
import BusinessInfo from "../pages/Business/partials/BusinessInfo";
import Customer from "../pages/Customer/Customer";
import ViewCustomer from "../pages/Customer/partials/ViewCustomer";
import Dashboard from "../pages/Dashboard/Dashboard";
import Invoice from "../pages/Invoice/Invoice";
import InvoiceForm from "../pages/Invoice/partials/InvoiceForm";
import ViewInvoice from "../pages/Invoice/partials/ViewInvoice";
import Product from "../pages/Product/Product";
import ViewProduct from "../pages/Product/partials/ViewProduct";
import ProductCategory from "../pages/Product/ProductCategory";
import EmailSettings from "../pages/Settings/partials/EmailSettings";
import SettingsProfile from "../pages/Settings/partials/Profile";
import Settings from "../pages/Settings/Settings";
import TopProfile from "../pages/Profile/Profile";

import Tax from "../pages/Tax/Tax";
import Discount from "../pages/Discount/Discount";
import DirectPaymentLink from "../pages/Payment/DirectPaymentLink";
import Transaction from "../pages/Transaction/Transaction";
import TransactionDetail from "../pages/Transaction/partials/TransactionDetail";
import Support from "../pages/Support/Support";
import ShipmentList from "../pages/Shipment/ShipmentList";
import ShipmentDetail from "../pages/Shipment/ShipmentDetail";
import OrderList from "../pages/Order/OrderList";
import OrderDetail from "../pages/Order/OrderDetail";
import CommunicationHub from "../components/communications/CommunicationHub";
import InvitationList from "../components/invitations/InvitationList";


export default function routes() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/invoice" element={<Invoice />} />
        <Route path="/create-invoice" element={<InvoiceForm />} />
        {/* <Route path="/create-invoice" element={<TestUI />} /> */}
        <Route path="/view-invoice/:id" element={<ViewInvoice />} />
        <Route path="/customer" element={<Customer />} />
        <Route path="/customer-detail/:id" element={<ViewCustomer />} />
        <Route path="/product" element={<Product />} />
        <Route path="/product-detail/:id" element={<ViewProduct />} />
        <Route path="/product-category" element={<ProductCategory />} />
        <Route path="/business" element={<Business />} />
        <Route path="/business-detail/:id" element={<BusinessInfo />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/settings/email" element={<EmailSettings />} />
        <Route path="/settings/profile" element={<SettingsProfile />} />
        <Route path="/profile" element={<TopProfile />} />

        <Route path="/tax" element={<Tax />} />
        <Route path="/discount" element={<Discount />} />
        {/* <Route path="/direct-payment" element={<DirectPaymentLink />} /> */}
        <Route path="/transaction" element={<Transaction />} />
        <Route path="/transaction-detail/:id" element={<TransactionDetail />} />
        <Route path="/shipments" element={<ShipmentList />} />
        <Route path="/shipment/:id" element={<ShipmentDetail />} />
        <Route path="/orders" element={<OrderList />} />
        <Route path="/orders/:id" element={<OrderDetail />} />
        <Route path="/communications" element={<CommunicationHub />} />
        <Route path="/invitations" element={<InvitationList />} />
        <Route path="/support" element={<Support />} />
      </Routes>
    </div>
  );
}
